import React from 'react';
import './ReportsAndAnalytics.css';

const ReportsAndAnalytics = () => {
  return (
    <div className="ReportsAndAnalytics">
      <h1>ReportsAndAnalytics</h1>
    </div>
  );
};

export default ReportsAndAnalytics;
